import React from 'react';
import { Link } from 'react-router-dom';
import SocialLinks from '../components/SocialLinks';
import './NotFound.css';

const NotFound = () => {
  return (
    <div className="not-found-wrapper">
      <div className="not-found-container">
        <h1 className="not-found-code">404</h1>
        <h2 className="not-found-title">Page Not Found</h2>
        <p className="not-found-message">
          The page you are looking for does not exist or has been moved.
        </p>
        <Link to="/" className="not-found-link">
          Go Back to Home
        </Link>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <SocialLinks variant="contact" showTitle={false} showWhatsappLine={false} />
        </div>
      </div>
    </div>
  );
};

export default NotFound;